import config from 'configDir/index';
import { get } from './http';

const baseUrl = '/taxi/operation';

// 近30天数据统计（截止到昨日）
const getLatest30daysRunStatisticService = get(
  `${baseUrl}/getLatest30daysRunStatistic`,
  config.terminalUrl,
);
//  近30天日均数据分析和近30天服务评价(环比)
const getLatest30daysStatisticHasLastService = get(
  `${baseUrl}/getLatest30daysStatisticHasLast`,
  config.terminalUrl,
);
// 近30天行驶时间分析
const getLatest30daysTimeCompareService = get(
  `${baseUrl}/getLatest30daysTimeCompare`,
  config.terminalUrl,
);
// 数据对比分析近3个月(营运趟次、行驶里程)
const getLatest3monthsCompareService = get(
  `${baseUrl}/getLatest3monthsCompare`,
  config.terminalUrl,
);
// 近30天行驶时间分析
const getLatest7monthsCompareService = get(
  `${baseUrl}/getLatest7monthsCompare`,
  config.terminalUrl,
);
// 时段分析（昨日）
const getYesterdayRunNumCompareService = get(
  `${baseUrl}/getYesterdayRunNumCompare`,
  config.terminalUrl,
);

// 实时数据(在线、离线、重车、空车)
const getCurrentCarStatisticService = get(`${baseUrl}/getCurrentCarStatistic`, config.terminalUrl);

// 运距分析（今日）
const getTodayOdometerStatisticService = get(
  `${baseUrl}/getTodayOdometerStatistic`,
  config.terminalUrl,
);

export {
  getLatest30daysRunStatisticService,
  getLatest30daysStatisticHasLastService,
  getLatest30daysTimeCompareService,
  getLatest3monthsCompareService,
  getLatest7monthsCompareService,
  getYesterdayRunNumCompareService,
  getCurrentCarStatisticService,
  getTodayOdometerStatisticService,
};
